import script from "./IDESideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDESideBar.vue?vue&type=script&lang=ts&setup=true"

import "./IDESideBar.vue?vue&type=style&index=0&id=4ede7ea0&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ede7ea0"]])

export default __exports__